// ReportHeaderProjectTotal Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import ProgressCircle from '../../../common/graph/progress_circle/progress_circle.jsx'
import currency from '../../../lib/currency.jsx'

class ReportHeaderProjectTotal extends Component {
  static get propTypes () {
    return {
      stat: PropTypes.object
    }
  }

  static get defaultProps () {
    return {
      stat: {}
    }
  }

  render () {
    const stat = this.props.stat
    const outerColor = '#486177'
    const innerColor = '#7abd9a'

    return (
      <div className='report-header-projecttotal'>
        <div className='title'>
          <IntlMessage ident='report.list.projectHeaderTotal' />
        </div>
        <div className='cont'>
          <ProgressCircle
            value={parseFloat(stat.totalPerc)}
            innerColor={innerColor}
            outerColor={outerColor}
            borderWidth='6'
          />
        </div>
        <div className='info'>
          <div className='info-item margin'>
            <span className='label'>
              <IntlMessage ident='report.list.projectLabelMargin' />
            </span>
            <h4 className='value'>{currency.formatSymbol(stat.totalMargin)}</h4>
          </div>
          <div className='info-item invoice'>
            <span className='label'>
              <IntlMessage ident='report.list.projectLabelInvoice' />
            </span>
            <h4 className='value'>
              {currency.formatSymbol(stat.totalInvoiced)}
            </h4>
          </div>
        </div>
      </div>
    )
  }
}

export default ReportHeaderProjectTotal
